import React from "react";
import {
  BrowserRouter as Router
} from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import { useAuth } from "./context/authContext";
import Routing from "./router";

export default function App() {
  const { currentUser } = useAuth();

    return (
      <Router>
        {currentUser? <Navbar/> : null} {/* ternary operator*/}
        <Routing/>
      </Router>
    );
  }